import { createSlice } from "@reduxjs/toolkit/react";

export type NotificationType = "success" | "error" | "info" | "warning";
export type Notification = {
  type: NotificationType | null;
  message: string | null;
};

const initialState: Notification = {
  type: null,
  message: null,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (_, action: { payload: Notification }) => {
      return action.payload;
    },
    clearNotification: () => {
      return initialState;
    },
  },
});


export const { setNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;